import React from "react";
import Layout from "@/components/Layout";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";

const CancellationReplacements = () => {
  return (
    <>
      <SEO title="Cancellation & Replacement Policy - Send a Sloth" />
      <Layout>
        <h1 className="text-center text-[#294870] text-4xl lg:text-5xl font-bold">
          Cancellation & Replacement Policy
        </h1>
        <div className="flex items-center justify-center py-8 w-full h-auto">
          <div className="max-w-3xl text-lg text-gray-700 leading-relaxed space-y-6">
            <h2 className="text-2xl font-semibold text-[#294870]">
              Order Cancellation
            </h2>
            <p>
              You may cancel your order within{" "}
              <span className="font-semibold">24 hours</span> of placing it. To
              cancel your order, please contact us immediately at{" "}
              <a
                href="mailto:info@sloths.co.uk"
                className="text-blue-500 underline"
              >
                info@sloths.co.uk
              </a>{" "}
              .
            </p>
            <p>
              If your order has already been shipped, you may need to follow our
              return policy to return the item. Please refer to our{" "}
              <a href="/returns" className="text-blue-500 underline">
                Returns Policy
              </a>{" "}
              for more information.
            </p>

            <h2 className="text-2xl font-semibold text-[#294870]">
              Replacements
            </h2>
            <p>
              We strive to ensure that all orders are fulfilled accurately.
              However, if you receive an incorrect or damaged item, please
              contact us immediately. We will arrange for a replacement as soon
              as possible.
            </p>
            <p>
              If a replacement is not possible, we will offer you a full refund
              for the item.
            </p>

            <h3 className="text-xl font-semibold text-[#294870]">Contact Us</h3>
            <p>
              If you have any questions about our cancellation or replacement
              policy, please contact us at:
            </p>
            <address className="not-italic space-y-1">
              <p>Send a Sloth</p>
              <p>Mango Drum Ltd.</p>
              <p>86-90 Paul Street, London, England, EC2A 4NE</p>
              <p>
                Email:{" "}
                <a
                  href="mailto:info@sloths.co.uk"
                  className="text-blue-500 underline"
                >
                  info@sloths.co.uk
                </a>
                ,{" "}
                <a
                  href="mailto:amazon@sloths.co.uk"
                  className="text-blue-500 underline"
                >
                  amazon@sloths.co.uk
                </a>
              </p>
            </address>
          </div>
        </div>
      </Layout>
      <Footer />
    </>
  );
};

export default CancellationReplacements;
